// extracted by mini-css-extract-plugin
export default {"tableContainer":"OrderTable_tableContainer__Lz0-0"};